import { render, staticRenderFns } from "./hpTabContent.vue?vue&type=template&id=0c73f962"
import script from "./hpTabContent.vue?vue&type=script&lang=js"
export * from "./hpTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports